import React from "react";
import { useNavigate } from "react-router-dom";
import COLORS from "../Helpers/utils";
import ComponentCard from "./ComponentCard";
import {BaseComponentImpl} from "../types/implementations";

interface ComponentSectionProps {
    title: string;
    components: BaseComponentImpl[];
    buildingKey: string;
    icon?: string;
}

const ComponentSection: React.FC<ComponentSectionProps> = ({ title, components, buildingKey, icon }) => {
    const navigate = useNavigate();

    const handleNavigate = (componentKey: string) => {
        navigate(`/building/${buildingKey}/component/${componentKey}`);
    };

    let path = undefined
    if (icon) {
        path = require(`../Images/${icon}.png`);
    }

    return (
        <div>
            <div style={{display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '6px'}}>
                {path && <img src={path} style={{width: '24px', height: '24px'}}/>}
                <h3 style={{margin: 0}}>{title}</h3>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", backgroundColor: COLORS.lightGrey, padding: '20px', borderRadius: '10px' }}>
                {components.map((component, index) => (
                    <ComponentCard
                        key={index}
                        component={component}
                        buildingKey={buildingKey}
                        onNavigate={handleNavigate}
                    />
                ))}
            </div>
        </div>
    );
};

export default ComponentSection;